import React, { useEffect, useState } from "react";
import { Card, Button, Col, Row, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import apis from "../../../api/stateAPI";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import ConfirmOnExit from "../../../components/confirmOnExit/ConfirmOnExit";
import messageToast from "../../../components/messageToast/messageToast";

function ConsumableEntryForm() {
  const { state } = useLocation();
//  const { Panel } = Collapse;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    category: [],
  });
  const [showDialog, setShowDialog] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const userData = useSelector((state) => state.auth);
  const handleClickBack = () => {
    navigate("/consumableEntryNew");
  };
 
  const { handleSubmit } = useForm();

  useEffect(() => {
    if (state?.data) {
      setFormData(state.data);
    } else {     
      apis.getNewConsumableAll({ outlet_id: state?.outlet_id }).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data || [];         
          const category = data.map(item => ({
            id: item.id,
            category: item.category,
            consumable_name: item.consumable_name,
            qty: item.qty
          }));          
          setFormData({ ...state, category });      
        }
      });
    }
  }, [state?.data, state?.outlet_id]);
  
  const handleScoreChange = (i, event) => {
    const { name, value } = event.target;
    let data = [...formData.category];  
    data[i][name] = value;
    setFormData((fd) => ({ ...fd, category: data }));
  };

  const onFinish = () => {
    const outlet_id = state?.outlet_id;
    setShowDialog(false);
    setApiError("");  
    const submitted = {
      id: formData.id || "",  
      outlet_id: outlet_id,
      material_group: formData.category.map((item) => ({
        id: item.id,
        consumable_name: item.consumable_name,
        qty: item.qty,       
      })),
      created_by: userData.userData.data?.id || "0",
    }; 
    console.log(submitted,'submitted');
    setLoading(true);  
    apis.addNewConsumableEntry(submitted)
      .then((res) => {
        if (res.data.status === 200) {        
          setTimeout(() => {
            messageToast({
              message: res.data.statusText,
              statusText: res.data.statusText,
              title: "Consumable Entry Submitted"
            });
            navigate("/consumableEntryNew");
          }, 2000);
        } else if (res.data.status === 300) {        
          messageToast({
            message: res.data.statusText,
            statusText: res.data.statusText,
            title: "Consumable Entry Warning"
          });
          setLoading(false);
        } else {         
          setApiError(res?.data?.message ?? "Something went wrong");
          setLoading(false);
        }
      })
      .catch(() => {             
        setApiError("Failed to submit. Please try again.");
        setLoading(false);
      });
  };  

  return (
    <>
      <Card>
        <ConfirmOnExit showModel={showDialog} />
        <Row style={{ justifyContent: "center" }}>
          <Col span={24}>
            <Form
              onFieldsChange={() => setShowDialog(true)}
              name="basic"
              form={form}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              autoComplete="off"
            >
              <Row gutter={[15, 0]}>
              <Col span={24}>
                  {formData.category.length > 0
                    ? formData.category.map((cat, i) => (
                        <div
                          key={i}
                          style={{                                    
                            width:"850px",
                            borderRadius: "8px",                          
                          }}
                        >         
                          <div
                            style={{
                              display: "flex",
                              padding: "4px",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              background: "#f0f0f0",
                              borderRadius: "4px",
                              marginBottom: "4px"
                            }}
                          >
                            <span
                              style={{
                                color: "#98086C",
                                fontWeight: "bold",
                                flex: 1
                              }}
                            >
                              {cat.consumable_name}
                            </span>
                            <Form.Item
                              style={{ margin: 0 }}
                              name={`stock_qty_${i}`}
                              rules={[
                                {
                                  pattern: /^[0-9]+$/g,
                                  message: "Invalid quantity"
                                }
                              ]}
                            >
                           <Input
                              required
                              type="number"
                              min="0"
                              style={{ width: "70px" }}
                              onChange={(e) => handleScoreChange(i, e)}
                              name="qty"
                              placeholder=""
                            /> 
                            </Form.Item>
                          </div>
                        </div>
                      ))
                    : "No Data"}
                </Col>
                <Col span={24}>
                  <Row
                    gutter={[15, 15]}
                    style={{ justifyContent: "center", marginTop: "20px" }}
                  >
                    <Col span={12} style={{ textAlign: "right" }}>
                      <Form.Item
                        wrapperCol={{ offset: 8, span: 16, padding: "15px" }}
                      >
                        <Button
                          style={{ backgroundColor: "#34b1aa" }}
                          type="primary"
                          onClick={handleSubmit(onFinish)}
                          loading={loading}
                        >
                          {"Submit"}
                        </Button>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item>
                        <Button onClick={handleClickBack}>Back</Button>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[15, 15]} style={{ justifyContent: "center" }}>
                    <Col span={12} style={{ textAlign: "right" }}>
                      {typeof apiError === "object" ? (
                        Object?.values(apiError)?.map((e) => (
                          <div key={e?.[0]} className="text-danger">
                            {e?.[0]}
                          </div>
                        ))
                      ) : (
                        <div className="text-danger">{apiError}</div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ConsumableEntryForm;
